'use strict';

import List from './challenges.list.ctrl';
import New from './challenges.new.ctrl';
import Demand from './challenges.demand.ctrl';
import Participants from './challenges.participants.ctrl';
import Weather from './challenges.weather.ctrl';
import Events from './challenges.events.ctrl';

export default angular
  .module('main.challenges', [
    List,
    New,
    Demand,
    Participants,
    Weather,
    Events
  ])
  .name;
